export const BRIDGE_V1_ID = "v1-bridge-09-12-2024";
export const BRIDGE_V2_ID = "v2-bridge-25-03-2026";

export const DSCR_V1_ID = "v1-dscr-09-12-2024";
